import { hasPaymentMetadataOrders } from '@ca/common'
import { trpcProxyClient } from 'api/ApiProvider'

// ERP metadata for the orders, or null when it failed or is still empty
export const fetchGlobemedMetadata = async (orderIds: number[]) => {
  try {
    const result = await trpcProxyClient.order.payments.metadata.query({
      order_ids: orderIds,
    })
    return hasPaymentMetadataOrders(result) ? result : null
  } catch {
    return null
  }
}
